import { AuthenticatedUser } from "@intentsify/types";
import { YourCampaignsScreenDefinition } from "screens";
import { consumeReturnPath } from "./returnPath";
import { AgreementScreenDefinition } from "./screens/Agreement/Agreement.definition";

const getPostLoginRoute = (
  user: AuthenticatedUser,
  oauthPath?: string,
): string => {
  if (!user.isActive) {
    return AgreementScreenDefinition.navigate();
  }

  const returnPath = consumeReturnPath();

  if (oauthPath) {
    return oauthPath;
  }

  return returnPath ?? YourCampaignsScreenDefinition.navigate();
};

export { getPostLoginRoute };
